import {useAuth} from "../AuthProvider";
import LoginComponent from "../components/login";
import {redirectToGoogleLogin, redirectToRitLogin} from "../auth";

export function LoginPage() {
    const {loginRit, loginGoogle, isAuthenticated} = useAuth();

    if (isAuthenticated) {
        // optional: redirect home or show message
        return (
            <div className="px-6">
                <p>You are already signed in.</p>
            </div>
        );
    }

    return (
        <div className="flex justify-center">
            <div className="w-full max-w-md px-6">
                <LoginComponent
                    onGoogleLogin={redirectToGoogleLogin}
                    onRitLogin={redirectToRitLogin}/>
            </div>
        </div>
    );
}
